import React from 'react';
import { Route, useLocation, useRouteMatch } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import FullHeightBox from '../boxes/FullHeightBox';
import Tabs from './Tabs';
import FadeSwitch from '../switches/FadeSwitch';
import RoundedWhiteBox from '../boxes/RoundedWhiteBox';
import useAvailableHeight from '../../hooks/useAvailableHeight';
import useCurrentTab from '../../hooks/useCurrentTab';
import { getTabRouteLocation, isDetailRoute } from '../../helpers/fingo-paper-tabs';

const FullHeightPaper = ({ tabs, useFingoWatermark, scrollableTabs, ...props }) => {
  const { path: routePath } = useRouteMatch();
  const theme = useTheme();
  const filteredTabs = tabs.filter(({ show, disabled }) => show && !disabled);
  const hasManyTabs = filteredTabs.length > 1;
  const location = useLocation();
  const [height, refChange] = useAvailableHeight();
  const currentTabIndex = useCurrentTab(filteredTabs);

  const routeLocation = getTabRouteLocation(location, routePath, filteredTabs[0]?.path);

  const activeTab = filteredTabs[currentTabIndex];
  const backgroundColor = activeTab?.detailBackgroundColor
    && isDetailRoute(location.pathname, routePath, activeTab.path)
    ? activeTab.detailBackgroundColor
    : 'transparent';
  return (
    <FullHeightBox
      backgroundColor="white"
      paddingTop={{ xs: 0, md: 5.5 }}
      paddingX={{ xs: 0, md: 8 }}
      paddingBottom={{ xs: 0, md: 10 }}
    >
      <Tabs
        tabs={filteredTabs}
        useFingoWatermark={useFingoWatermark}
        scrollableTabs={scrollableTabs}
      />
      <RoundedWhiteBox
        hasManyOptions={hasManyTabs}
        height={height}
        ref={refChange}
        sx={{
          flex: 1,
          bgcolor: backgroundColor,
          border: '2px solid',
          borderColor: 'secondary.A200',
          borderTopLeftRadius: currentTabIndex === 0 ? 0 : theme.shape.borderRadius * 6,

        }}
        {...props}
      >
        <FadeSwitch depth={4} customLocation={routeLocation}>
          {filteredTabs.map(({ id, label, path, component }) => (
            <Route id={id} key={label} path={`${routePath}/${path}`}>
              {component}
            </Route>
          ))}
        </FadeSwitch>
      </RoundedWhiteBox>
    </FullHeightBox>
  );
};

FullHeightPaper.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.shape()]).isRequired,
      path: PropTypes.string.isRequired,
      component: PropTypes.element.isRequired,
      disabled: PropTypes.bool.isRequired,
      show: PropTypes.bool.isRequired,
      quantity: PropTypes.number,
      detailBackgroundColor: PropTypes.string,
    }),
  ).isRequired,
  useFingoWatermark: PropTypes.bool,
  scrollableTabs: PropTypes.bool,
};

FullHeightPaper.defaultProps = {
  useFingoWatermark: false,
  scrollableTabs: false,
};

export default FullHeightPaper;
